import React from 'react';
import { useSelector } from 'react-redux';
import CompanyAssignedTableComponent from './companyAssignedTable.component';

function CompanyAssignedTableContainer() {
  const isLoading = useSelector((state) => state.dashboard.companyAssignedRecords.isLoading);
  const data = useSelector((state) => state.dashboard.companyAssignedRecords.data);
  const error = useSelector((state) => state.dashboard.companyAssignedRecords.error);

  return (
    <CompanyAssignedTableComponent
      isLoading={isLoading}
      data={data}
      error={error}
    />
  );
}

export default CompanyAssignedTableContainer;
